export const inputInitState = {
  login: '',
  password: '',
};

export const errorsInitState = {
  error: '',
  loginError: '',
  passwordError: '',
};

export const renderFlagsInitState = {
  loginFirstRender: true,
  passwordFirstRender: true,
};

export const AUTH_ERRORS = {
  INVALID_FORMAT: 'Проверьте формат почты',
  EMPTY_LOGIN: 'Укажите почту',
  EMPTY_PASSWORD: 'Укажите пароль',
  LOGIN_AND_PASSWORD_ERROR:
    'Неверная почта или пароль. Попробуйте ввести верную комбинацию ещё раз',
};
